/* eslint-disable import/prefer-default-export */

import { createAction } from "redux-actions";
import * as types from "./constants";

export const setOrganization = createAction(types.ORGANIZATION_SET);
